import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.filter.js";
export var BASE_PLAYLIST_KEY = 'playlists';
var playlistKeys = {
  allPlaylists: [BASE_PLAYLIST_KEY],
  playlists: function playlists(teamId) {
    return [BASE_PLAYLIST_KEY, 'team', Number(teamId)];
  },
  singlePlaylist: function singlePlaylist(id) {
    return [BASE_PLAYLIST_KEY, 'single', Number(id)];
  },
  singlePlaylistDetails: function singlePlaylistDetails(id) {
    return [].concat(_toConsumableArray(playlistKeys.singlePlaylist(id)), ['details']);
  },
  singlePlaylistContent: function singlePlaylistContent(id) {
    return [].concat(_toConsumableArray(playlistKeys.singlePlaylist(id)), ['content']);
  },
  mySinglePlaylistDetails: function mySinglePlaylistDetails(id) {
    return [].concat(_toConsumableArray(playlistKeys.singlePlaylist(id)), ['details', 'my']);
  },
  mySinglePlaylistContent: function mySinglePlaylistContent(id) {
    return [].concat(_toConsumableArray(playlistKeys.singlePlaylist(id)), ['content', 'my']);
  },
  myPlaylistsToBrowse: function myPlaylistsToBrowse(offset, limit, params) {
    return [BASE_PLAYLIST_KEY, 'my', 'browse', offset, limit, params];
  },
  myRecommendedPlaylists: function myRecommendedPlaylists(limit, offset) {
    return [BASE_PLAYLIST_KEY, 'my', 'recommendations', limit, offset];
  },
  playlistsAudience: function playlistsAudience(ids) {
    return [BASE_PLAYLIST_KEY, 'audience', ids === null || ids === void 0 ? void 0 : ids.sort().toString()];
  },
  userPlaylists: function userPlaylists(userId, limit) {
    return [BASE_PLAYLIST_KEY, 'user', Number(userId), Number(limit)];
  },
  myBadgePlaylists: function myBadgePlaylists(limit, page) {
    return [BASE_PLAYLIST_KEY, 'my', 'badge', Number(limit), Number(page)];
  },
  playlistList: function playlistList(search, page) {
    return [BASE_PLAYLIST_KEY, 'list', search, page].filter(Boolean);
  },
  playlistAccessData: [BASE_PLAYLIST_KEY, 'access'],
  playlistAccessDataSelection: function playlistAccessDataSelection(playlistIds) {
    return [BASE_PLAYLIST_KEY, 'access', playlistIds === null || playlistIds === void 0 ? void 0 : playlistIds.sort().toString()];
  },
  multiPlaylistsDetails: function multiPlaylistsDetails(playlistIds) {
    return [BASE_PLAYLIST_KEY, 'multi', playlistIds === null || playlistIds === void 0 ? void 0 : playlistIds.sort().toString()];
  }
};
export default playlistKeys;